import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    callList: [],
    truckList: [],
    invoiceRecord: {}
};

export const dispatchCallsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DISPATCH_CALL_LIST:
            return { ...state, callList: action.callList || [] };
        case actionTypes.GET_DISPATCH_TRUCK_LIST:
            return { ...state, truckList: action.truckList || [] };
        case actionTypes.GET_INVOICE_DETAILS:
            return { ...state, invoiceRecord: action.invoiceRecord || {} };
        default:
            return state;
    }
};
